
import math, { bignumber } from './math'
export function fetchFields(exp) {
    const distinctFields = []
    const fields = exp.split(/[+\-\*//(/)]/)
    if (fields.length) {
        fields.forEach(f => {
            if (distinctFields.indexOf(f) === -1) {
                distinctFields.push(f)
            }
        });
    }
    return distinctFields
}
export function compute(exp, root, scale) {
    let sum
    const fields = fetchFields(exp)
    const isOpen = exp.indexOf('*') === -1 && exp.indexOf('/') === -1
    const scope = {}
    let varCode = 'a'.charCodeAt()
    const varMap = {}
    let hasValue = !isOpen
    
    let numReg = /^(-?\d+)(\.\d+)?$/
    for (let i = 0; i < fields.length; i++) {
        const f = fields[i];

        try {
            const field = f.trim()
            if (field) {
                //如果是数字则跳过
                if (numReg.test(field)) {
                    continue
                }
                let v = root[field]
                if (isOpen) {
                    if (!v) {
                        v = 0
                    } else {
                        hasValue = true
                    }
                } else {
                    if (!v && v !== 0) {
                        hasValue = false
                        break
                    }
                }


                if (!scope[field]) {
                    const varName = String.fromCharCode(varCode)
                    scope[varName] = bignumber(v)
                    varMap[varName] = field
                    varCode += 1
                }
            }
        } catch (e) {
            hasValue = false
            console.log(e)
        }
    };

    if (hasValue) {

        for (const key in varMap) {
            if (Object.hasOwnProperty.call(varMap, key)) {
                const field = varMap[key];
                exp = exp.replace(field, key)
            }
        }
        sum = math.evaluate(exp, scope)
        let v
        if (scale) {
            v = sum.toDP(2).toString()
        } else {
            v = sum.toString()
        }

        if (v === 'Infinity') {
            v = undefined
        }
        return v
    }


}